import { Select } from 'antd';
import React, { JSX, Suspense } from 'react';

interface ISuspenseList {
    children: JSX.Element;
    style?: React.CSSProperties;
}

const SuspenseList: React.FC<ISuspenseList> = ({ children, style }) => {
    return (
        <Suspense
            fallback={
                <Select
                    style={{ width: '100%', ...style }}
                    disabled={true}
                    placeholder="select option ..."
                    loading={true}
                />
            }
        >
            {children}
        </Suspense>
    );
};

export default SuspenseList;
